export default "__VITE_ASSET__DI8WDhHM__"